"use client";

import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import { flutterStatsData, flutterTechnologiesData } from "src/utils/mock/webAppData";
import {
  SurveyIntelligenceHeroData,
  surveyIntelligenceAboutData,
  surveyIntelligenceDevelopSolutionsAndProcessData,
  surveyIntelligenceFaqData,
} from "src/utils/mock/surveyIntelligenceData";
import { uiPortfolioData } from "src/utils/mock/uiuxData";

export default function SurveyIntelligence({ caseStudies }) {
  const liveProjects = caseStudies?.projects?.liveProjects || [];

  const activeProjects = liveProjects.filter((project) => {
    return project.projectStatus?.toLowerCase() === "active";
  });

  const filteredData = caseStudies
    ? {
        ...uiPortfolioData,
        projects: {
          liveProjects: activeProjects,
        },
      }
    : uiPortfolioData;
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;

  return (
    <div>
      <AppHero heroData={SurveyIntelligenceHeroData} />
      <TechStats stats={flutterStatsData} />
      <WhyChooseUs data={surveyIntelligenceDevelopSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-text-primary px-6! md:px-12! relative overflow-hidden font-sans ">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-500/5 dark:bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-500/5 dark:bg-blue-950/10 blur-[150px] -z-10 rounded-full" />
        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={flutterTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About Onsite Surveys & Feedback Intelligence" sections={surveyIntelligenceAboutData} />
        </div>
      </section>
      <FAQSection faqs={surveyIntelligenceFaqData} />
      <CommonContactSection />
    </div>
  );
}
